import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed inset-0 flex items-center justify-center z-50" style="background: rgba(255,255,255,0.6); backdrop-filter: blur(8px);">
      <div class="flex flex-col items-center p-8" style="background: var(--color-surface-raised); border: 1px solid var(--color-border-default); border-radius: var(--radius-xl); box-shadow: var(--shadow-lg); animation: modalSlideUp 350ms cubic-bezier(0.16, 1, 0.3, 1);">
        <div class="relative">
          <div class="spinner spinner-lg"></div>
          <div class="absolute inset-0 rounded-full" style="border: 3px solid transparent; border-top-color: var(--color-brand-end); animation: spin 1.5s linear infinite reverse; opacity: 0.4;"></div>
        </div>
        <p class="mt-4 text-sm font-medium" style="color: var(--color-text-secondary);">{{ 'COMMON.LOADING' | translate }}</p>
      </div>
    </div>
  `
})
export class LoaderComponent {}
